<script lang="ts">
  import RepositoryFactory, { CONTRACT } from '../../repositories/RepositoryFactory';
  import { loginUser } from '../../components/auth/LoginUser';

  let telNo: string,
    email: string,
    confirmEmail: string,
    telNoError = false,
    emailError = false,
    confirmEmailError = false,
    isDisabled = false; // onceを使うと修正後に押せなくなるのでフラグを用意

  function doPost() {
    if (isDisabled) {
      return false;
    }
    let errorMessage = '';
    isDisabled = true;
    telNoError = false;
    emailError = false;
    confirmEmailError = false;

    if (!telNo && !email) {
      alert('入力項目がありません');
      telNoError = true;
      emailError = true;
      isDisabled = false;
      return false;
    }

    // 電話番号変更
    if (telNo && (telNo.length < 10 || telNo.length > 11)) {
      telNoError = true;
      errorMessage += '電話番号が正しくありません\n';
    }

    // メールアドレス変更
    if (email || confirmEmail) {
      let reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
      emailError = !reg.test(email);
      confirmEmailError = !reg.test(confirmEmail);

      if (emailError || confirmEmailError) {
        errorMessage += 'メールアドレスの形式が正しくありません\n';
      } else if (email !== confirmEmail) {
        emailError = true;
        confirmEmailError = true;
        errorMessage += 'メールアドレスが異なります';
      }
    }

    if (errorMessage) {
      isDisabled = false;
      alert(errorMessage);
      return false;
    }

    const contractRepository = RepositoryFactory[CONTRACT];
    contractRepository
      .changeContract({
        telNo: telNo,
        email: email
      })
      .then((res) => {
        alert('変更が完了しました');
        handleClose();
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        }
      });
  }

  const handleClose = () => {
    // [Note] COM-4525
    // モーダルライブラリの変更に伴いdispatchでの処理を見直し
    // 更新完了、閉じるでlocation.reloadを呼び出していたので踏襲する
    location.reload();
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">連絡先変更</h1>
    </div>
  </div>

  <div class="shadow rounded bg-gray-50 border-t-4 border-green-400">
    <div class="flex flex-col ml-5 mr-5">
      <div class="flex-1">
        <div class="inline-grid grid-cols-4 justify-items-center items-center min-w-full p-2">
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <span class="form-label-title">連絡先電話番号</span>
          </div>
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <input
              type="tel"
              bind:value={telNo}
              class={telNoError ? 'required-error' : ''}
              maxlength="11"
              placeholder="0300000000"
            />
          </div>
        </div>
      </div>

      <div class="flex-1">
        <div class="inline-grid grid-cols-4 justify-items-center items-center min-w-full p-2">
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <span class="form-label-title">メールアドレス</span>
          </div>
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <input
              type="email"
              bind:value={email}
              class={emailError ? 'required-error' : ''}
              placeholder="xxxx@xxxx.jp"
            />
          </div>
        </div>
      </div>
      <div class="flex-1">
        <div class="inline-grid grid-cols-4 justify-items-center items-center min-w-full p-2">
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <span class="form-label-title">メールアドレス（再入力）</span>
          </div>
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <input
              type="email"
              bind:value={confirmEmail}
              class={confirmEmailError ? 'required-error' : ''}
              placeholder="xxxx@xxxx.jp"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mr-10 mt-6 flex mx-auto justify-end">
    <button class="button-secondary" on:click={handleClose}>閉じる</button>
    <button class="button-primary ml-4" on:click={doPost}>変更</button>
  </div>
</div>

<style lang="postcss">
  .required-error {
    background-color: #ffccff;
  }
  .form-label-title {
    @apply font-semibold text-gray-700;
  }
  input[type='tel'],
  input[type='email'] {
    width: 100%;
    @apply rounded border py-2 px-3 text-sm placeholder-gray-400 focus:placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-transparent;
  }
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-secondary {
    @apply bg-gray-300 rounded-lg hover:bg-gray-400 text-gray-500 focus:outline-none px-10 py-2;
  }
</style>
